'use es6';

export const HAS_FILE_ATTACHMENT = ['hasFileAttachment'];
export const PREVIEW_TEXT = ['previewText'];
export const PREVIEW_MESSAGE_ID = ['previewMessageId'];
export const FAILED = ['failed'];
export const RESPONDER = ['responder'];
export const VISITOR = ['visitor'];